<template>
  <div style="margin: 0 20px;padding-bottom: 20px;height: 8050px;overflow: hidden">
    <div style="height: 80px;line-height:80px;font-size: 26px;text-align: center">
      <span v-if="isAdd">新增 - </span>
      <strong v-if="moduletag === 2">【{{addEditObj.oldPersonRow.elderly_name}}】老年人能力评估基本信息表</strong>
      <strong v-else>【{{addEditObj.oldPersonRow.name}}】老年人能力评估基本信息表</strong>
    </div>
<!--    <el-button size="small" type="primary" icon="el-icon-download" plain @click="exportToPdf">导出PDF</el-button>-->
    <div ref="contentToConvert" style="letter-spacing: 4px;" class="no-zoom-container">
      <div class="clause-title-line" style="background-color: aliceblue;margin: 0 0 20px"><span>一、能力评估基本信息</span></div>
      <div class="box-card">
        <div class="m-top">
          <span style="font-weight: bold;">姓名：</span>
          <span v-if="moduletag === 2"> {{oldPerson.elderly_name}}</span>
          <span v-else> {{oldPerson.name}}</span>
        </div>
        <div class="m-top">
          <span style="font-weight: bold;">性别：</span>
          <span v-if="moduletag === 2"> {{getgender(oldPerson.gender)}}</span>
          <span v-else><span v-if="oldPerson.sex === 0">女</span><span v-if="oldPerson.sex === 1">男</span></span>
        </div>
        <div class="m-top" style="height: 40px">
          <span style="font-weight: bold;">身份证号：</span>
          <span v-if="moduletag === 2"> {{oldPerson.id_number}}</span>
          <span v-else> {{oldPerson.idcard_num}}</span>
        </div>
      </div>
      <div class="clause-title-line" style="background-color: aliceblue"><span>二、自理能力指标</span></div>
      <div class="box-card">
        <div class="h-line-show">1、进食(使用适当的器具将食物送入口中并咽下)：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.eating_behavior_score_code">
          <el-radio class="m-top" :label="'4'">独立使用器具将食物送进口中并咽下,没有呛咳</el-radio>
          <el-radio class="m-top" :label="'3'">在他人指导或提示下完成,或独立使用辅具,没有呛咳</el-radio>
          <el-radio class="m-top" :label="'2'">进食中需要少量接触式协助,偶尔(每月一次及以上)呛咳</el-radio>
          <el-radio class="m-top" :label="'1'">在进食中需要大量接触式协助,经常(每周一次及以上)呛咳</el-radio>
          <el-radio class="m-top" :label="'0'">完全依赖他人协助进食,或吞咽困难,或留置营养管</el-radio>
        </el-radio-group>
        <div class="h-line-show">2、修饰(洗脸、刷牙、梳头、刮脸、剪指(趾)甲等): </div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.decoration_behavior_score_code">
          <el-radio class="m-top" :label="'4'">独立完成,不需要协助</el-radio>
          <el-radio class="m-top" :label="'3'">在他人指导或提示下完成</el-radio>
          <el-radio class="m-top" :label="'2'">需要他人协助,但以自身完成为主</el-radio>
          <el-radio class="m-top" :label="'1'">主要依靠他人协助,自身能给予配合</el-radio>
          <el-radio class="m-top" :label="'0'">完全依赖他人协助,且不能给予配合</el-radio>
        </el-radio-group><br/>
        <div class="h-line-show">3、洗澡(清洗和擦干身体)：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.bathing_behavior_score_code">
          <el-radio class="m-top" :label="'4'">独立完成,不需要协助</el-radio>
          <el-radio class="m-top" :label="'3'">在他人指导或提示下完成</el-radio>
          <el-radio class="m-top" :label="'2'">需要他人协助,但以自身完成为主</el-radio>
          <el-radio class="m-top" :label="'1'">主要依靠他人协助,自身能给予配合</el-radio>
          <el-radio class="m-top" :label="'0'">完全依赖他人协助,且不能给予配合</el-radio>
        </el-radio-group><br/>
        <div class="h-line-show">4、穿/脱上衣(穿/脱上身衣服、系扣、拉拉链等)：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.dressing_behavior_score_code">
          <el-radio class="m-top" :label="'4'">独立完成,不需要他人协助</el-radio>
          <el-radio class="m-top" :label="'3'">在他人指导或提示下完成</el-radio>
          <el-radio class="m-top" :label="'2'">需要他人协助,但以自身完成为主</el-radio>
          <el-radio class="m-top" :label="'1'">主要依靠他人协助,自身能给予配合</el-radio>
          <el-radio class="m-top" :label="'0'">完全依赖他人协助,且不能给予配合</el-radio>
        </el-radio-group><br/>
        <div class="h-line-show">5、穿/脱裤子和鞋袜(穿/脱裤子、鞋袜等)：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.extra_info.dressing_trousers_score_code">
          <el-radio class="m-top" :label="'4'">独立完成,不需要他人协助</el-radio>
          <el-radio class="m-top" :label="'3'">在他人指导或提示下完成</el-radio>
          <el-radio class="m-top" :label="'2'">需要他人协助,但以自身完成为主</el-radio>
          <el-radio class="m-top" :label="'1'">主要依靠他人协助,自身能给予配合</el-radio>
          <el-radio class="m-top" :label="'0'">完全依赖他人协助,且不能给予配合</el-radio>
        </el-radio-group><br/>
        <div class="h-line-show">6、小便控制(控制和排出尿液的能力)：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.urination_control_score_code">
          <el-radio class="m-top" :label="'4'">可自行控制排尿,排尿次数、排尿控制均正常</el-radio>
          <el-radio class="m-top" :label="'3'">白天可自行控制排尿次数,夜间出现排尿次数增多、排尿控制较差,或自行使用尿布、尿垫等辅助用物</el-radio>
          <el-radio class="m-top" :label="'2'">白天大部分时间可自行控制排尿,偶出现(每天&lt;1次,但每周&gt;1次)尿失禁,夜间控制排尿较差,或他人少量协助使用尿布、尿垫等辅助用物</el-radio>
          <el-radio class="m-top" :label="'1'">白天大部分时间不能控制排尿(每天≥1次,但尚非完全失控),夜间出现尿失禁,或他人大量协助使用尿布、尿垫等辅助用物</el-radio>
          <el-radio class="m-top" :label="'0'">小便失禁,完全不能控制排尿,或留置导尿管</el-radio>
        </el-radio-group><br/>
        <div class="h-line-show">7、大便控制(控制和排出粪便的能力)：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.defecation_control_score_code">
          <el-radio class="m-top" :label="'4'">可正常自行控制大便排出</el-radio>
          <el-radio class="m-top" :label="'3'">有时出现(每周&lt;1次)便秘或大便失禁,或自行使用开塞露、尿垫等辅助用物</el-radio>
          <el-radio class="m-top" :label="'2'">经常出现(每天&lt;1次,但每周&gt;1次)便秘或大便失禁,或他人少量协助使用开塞露、尿垫等辅助用物</el-radio>
          <el-radio class="m-top" :label="'1'">大部分时间均出现(每天≥1次)便秘或大便失禁,但尚非完全失控,或他人大量协助使用开塞露、尿垫等辅助用物</el-radio>
          <el-radio class="m-top" :label="'0'">严重便秘或者完全大便失禁,需要依赖他人协助排便或清洁皮肤</el-radio>
        </el-radio-group><br/>
        <div class="h-line-show">8、如厕(上厕所排泄大小便,并清洁身体<sup>a</sup>)：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.toilet_behavior_score_code">
          <el-radio class="m-top" :label="'4'">独立完成,不需要他人协助.</el-radio>
          <el-radio class="m-top" :label="'3'">在他人指导或提示下完成</el-radio>
          <el-radio class="m-top" :label="'2'">需要他人协助,但以自身完成为主</el-radio>
          <el-radio class="m-top" :label="'1'">主要依靠他人协助,自身能给予配合</el-radio>
          <el-radio class="m-top" :label="'0'">完全依赖他人协助,且不能给予配合</el-radio>
        </el-radio-group><br/>
        <div style="height: 30px;font-size: 12px">
          <span>a：评估中强调排泄前解开裤子、完成排泄后清洁身体、穿上裤子。</span>
        </div>
      </div>
      <div class="clause-title-line" style="background-color: aliceblue"><span>三、基础运动能力指标</span></div>
      <div class="box-card">
        <div class="h-line-show">9、床上体位转移(卧床翻身及坐起躺下)：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.extra_info.bed_body_transferring_score_code">
          <el-radio class="m-top" :label="'4'">独立完成,不需要他人协助</el-radio>
          <el-radio class="m-top" :label="'3'">在他人指导或提示下完成</el-radio>
          <el-radio class="m-top" :label="'2'">需要他人协助,但以自身完成为主</el-radio>
          <el-radio class="m-top" :label="'1'">主要依靠他人协助,自身能给予配合</el-radio>
          <el-radio class="m-top" :label="'0'">完全依赖他人协助,且不能给予配合</el-radio>
        </el-radio-group><br/>
        <div class="h-line-show">10、床椅转移(从坐位到站位,再从站位到坐位的转换过程)：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.bed_chair_transferring_score_code">
          <el-radio class="m-top" :label="'4'">独立完成,不需要他人协助</el-radio>
          <el-radio class="m-top" :label="'3'">在他人指导或提示下完成</el-radio>
          <el-radio class="m-top" :label="'2'">需要他人协助,但以自身完成为主</el-radio>
          <el-radio class="m-top" :label="'1'">主要依靠他人协助,自身能给予配合</el-radio>
          <el-radio class="m-top" :label="'0'">完全依赖他人协助,且不能给予配合</el-radio>
        </el-radio-group><br/>
        <div class="h-line-show">11、平地行走(双脚交互的方式在地面行动,总是一只脚在前<sup>a</sup>)：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.flat_walking_score_code">
          <el-radio class="m-top" :label="'4'">独立平地步行50m左右,不需要协助,无摔倒风险</el-radio>
          <el-radio class="m-top" :label="'3'">能平地步行50 m左右,存在摔倒风险,需要他人监护或指导,或使用拐杖、助行器等辅助工具.</el-radio>
          <el-radio class="m-top" :label="'2'">在步行时需要他人少量扶持协助</el-radio>
          <el-radio class="m-top" :label="'1'">在步行时需要他人大量扶持协助</el-radio>
          <el-radio class="m-top" :label="'0'">完全不能步行</el-radio>
        </el-radio-group><br/>
        <div class="h-line-show">12、上下楼梯(双脚交替完成楼梯台阶连续的上下移动)：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.stair_climbing_score_code">
          <el-radio class="m-top" :label="'3'">可独立.上下楼梯(连续上下10个~15个台阶),不需要协助</el-radio>
          <el-radio class="m-top" :label="'2'">在他人指导或提示下完成</el-radio>
          <el-radio class="m-top" :label="'1'">需要他人协助,但以自 身完成为主</el-radio>
          <el-radio class="m-top" :label="'0'">主要依靠他人协助,自身能给予配合;或者完全依赖他人协助,且不能给予配合</el-radio>
        </el-radio-group>
        <div style="height: 30px;font-size: 12px">
          <span>a：包括他人辅助和使用辅助具的步行。</span>
        </div>
      </div>
      <div class="clause-title-line" style="background-color: aliceblue"><span>四、精神状态指标</span></div>
      <div class="box-card">
        <div class="h-line-show">13、时间定向(知道并确认时间的能力)：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.extra_info.time_score_code">
          <el-radio class="m-top" :label="'4'">时间观念(年、月)清楚,日期(或星期几)可相差-天</el-radio>
          <el-radio class="m-top" :label="'3'">时间观念有些下降,年、月、日(或星期几)不能全部分清(相差两天或以上)</el-radio>
          <el-radio class="m-top" :label="'2'">时间观念较差,年、月、日不清楚,可知上半年或下半年或季节</el-radio>
          <el-radio class="m-top" :label="'1'">时间观念很差,年、月、日不清楚,可知上午、下午或白天、夜间</el-radio>
          <el-radio class="m-top" :label="'0'">无时间观念</el-radio>
        </el-radio-group><br/>
        <div class="h-line-show">14、空间定向(知道并确认空间的能力)：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.extra_info.space_score_code">
          <el-radio class="m-top" :label="'4'">能在日常生活范围内单独外出,如在日常居住小区内独自外出购物等</el-radio>
          <el-radio class="m-top" :label="'3'">不能单独外出,但能准确知道自己日常生活所在地的地址信息</el-radio>
          <el-radio class="m-top" :label="'2'">不能单独外出,但知道较多有关自己日常生活的地址信息</el-radio>
          <el-radio class="m-top" :label="'1'">不能单独外出,但知道较少自己居住或生活所在地的地址信息</el-radio>
          <el-radio class="m-top" :label="'0'">不能单独外出,无空间观念</el-radio>
        </el-radio-group><br/>
        <div class="h-line-show">15、人物定向(知道并确认人物的能力)：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.extra_info.person_score_code">
          <el-radio class="m-top" :label="'4'">认识长期共同一起生活的人,能称呼并知道关系</el-radio>
          <el-radio class="m-top" :label="'3'">能认识大部分共同生活居住的人,能称呼或知道关系</el-radio>
          <el-radio class="m-top" :label="'2'">能认识部分日常同住的亲人或照护者等,能称呼或知道关系等</el-radio>
          <el-radio class="m-top" :label="'1'">只认识自己或极少数日常同住的亲人或照护者等</el-radio>
          <el-radio class="m-top" :label="'0'">不认识任何人(包括自已)</el-radio>
        </el-radio-group><br/>
        <div class="h-line-show">16、记忆(短时、近期和远期记忆能力)：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.extra_info.memory_score_code">
          <el-radio class="m-top" :label="'4'">总是能保持与社会、年龄所适应的记忆能力,能完整的回忆</el-radio>
          <el-radio class="m-top" :label="'3'">出现轻度的记忆紊乱或回忆不能(不能回忆即时信息,3个词语经过5分钟后仅能回忆0个~1个)</el-radio>
          <el-radio class="m-top" :label="'2'">出现中度的记忆紊乱或回忆不能(不能回忆近期记忆,不记得上一顿饭吃了什么)</el-radio>
          <el-radio class="m-top" :label="'1'">出现重度的记忆紊乱或回忆不能(不能回忆远期记忆,不记得自己的老朋友)</el-radio>
          <el-radio class="m-top" :label="'0'">记忆完全紊乱或者完全不能对既往事物进行正确的回忆</el-radio>
        </el-radio-group><br/>
        <div class="h-line-show">17、理解能力(理解语言信息和非语言信息的能力(可借助平时使用助听设备等),即理解别人的话)：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.extra_info.comprehend_score_code">
          <el-radio class="m-top" :label="'4'">能正常理解他人的话</el-radio>
          <el-radio class="m-top" :label="'3'">能理解他人的话,但需要增加时间</el-radio>
          <el-radio class="m-top" :label="'2'">理解有困难,需频繁重复或简化口头表达</el-radio>
          <el-radio class="m-top" :label="'1'">理解有严重困难,需要大量他人帮助</el-radio>
          <el-radio class="m-top" :label="'0'">完全不能理解他人的话</el-radio>
        </el-radio-group><br/>
        <div class="h-line-show">18、表达能力(表达信息能力,包括口头的和非口头的,即表达自己的想法)：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.extra_info.expression_score_code">
          <el-radio class="m-top" :label="'4'">能正常表达自己的想法</el-radio>
          <el-radio class="m-top" :label="'3'">能表达自己的需要,但需要增加时间</el-radio>
          <el-radio class="m-top" :label="'2'">表达需要有困难,需频繁重复或简化口头表达</el-radio>
          <el-radio class="m-top" :label="'1'">表达有严重困难,需要大量他人帮助</el-radio>
          <el-radio class="m-top" :label="'0'">完全不能表达需要</el-radio>
        </el-radio-group><br/>
        <div class="h-line-show">19、攻击行为(身体攻击行为(如打/踢/推/咬/抓/摔东西)和语言攻击行为(如骂人、语言威胁、尖叫)<sup>a</sup>)：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.aggression_behavior_code">
          <el-radio class="m-top" :label="'1'">未出现</el-radio>
          <el-radio class="m-top" :label="'0'">近一个月内出现过攻击行为</el-radio>
        </el-radio-group><br/>
        <div class="h-line-show">20、抑郁症状(存在情绪低落兴趣减退、活力减退等症状,甚至出现妄想、幻觉、自杀念头或自杀行为<sup>b</sup>)：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.depression_symptom_code">
          <el-radio class="m-top" :label="'1'">未出现</el-radio>
          <el-radio class="m-top" :label="'0'">近一个月内出现过负性情绪</el-radio>
        </el-radio-group><br/>
        <div class="h-line-show">21、意识水平(机体对自身和周围环境的刺激做出应答反应的能力程度,包括清醒和持续的觉醒状态<sup>c</sup>)：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.extra_info.consciousness_score_code">
          <el-radio class="m-top" :label="'2'">神志清醒,对周围环境能做出正确反应</el-radio>
          <el-radio class="m-top" :label="'1'">嗜睡,表现为睡眠状态过度延长。当呼唤或推动老年人的肢体时可唤醒,并能进行正确的交谈或执行指令,停止刺激后又继续人睡;意识模糊,注意力涣散,对外界刺激不能清晰的认识,空间和时间定向力障碍,理解力迟钝,记忆力模糊和不连贯</el-radio>
          <el-radio class="m-top" :label="'0'">昏睡,一般的外界刺激不能使其觉醒,给予较强烈的刺激时可有短时的意识清醒,醒后可简短回答提问,当刺激减弱后又很快进人睡眠状态;或者昏迷:意识丧失,随意运动丧失,对一般刺激全无反应</el-radio>
        </el-radio-group><br/>
        <div style="font-size: 12px">
          <span>a：长期的行为状态。</span><br>
          <span>b：长期的负性情绪。</span><br>
          <span>c：处于昏迷状态者,直接评定为重度失能。</span>
        </div>
      </div>
      <div style="height: 10px"></div>
      <div class="clause-title-line" style="background-color: aliceblue"><span>五、感知觉与社会参与指标</span></div>
      <div class="box-card">
        <div class="h-line-show">22、视力(感受存在的光线并感受物体的大小、形状的能力。在个体的最好矫正视力下进行评估)：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.vision_code">
          <el-radio class="m-top" :label="'2'">视力正常</el-radio>
          <el-radio class="m-top" :label="'1'">能看清楚大字体,但看不清书报上的标准字体;视力有限,看不清报纸大标题,但能辨认物体</el-radio>
          <el-radio class="m-top" :label="'0'">只能看到光、颜色和形状;完全失明</el-radio>
        </el-radio-group><br/>
        <div class="h-line-show">23、听力(能辨别声音的方位、音调、音量和音质的有关能力(可借助平时使用助听设备等))：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.hearing_code">
          <el-radio class="m-top" :label="'2'">听力正常</el-radio>
          <el-radio class="m-top" :label="'1'">在轻声说话或说话距离超过2米时听不清;正常交流有些困难,需在安静的环境或大声说话才能听到</el-radio>
          <el-radio class="m-top" :label="'0'">讲话者大声说话或说话很慢,才能部分听见;完全失聪</el-radio>
        </el-radio-group><br/>
        <div class="h-line-show">24、执行日常事务(计划、安排并完成日常事务,包括但不限于洗衣服、小金额购物、服药管理)：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.extra_info.daily_code">
          <el-radio class="m-top" :label="'4'">能完全独立计划、安排和完成日常事务,无需协助</el-radio>
          <el-radio class="m-top" :label="'3'">在计划、安排和完成日常事务时需要他人监护或指导</el-radio>
          <el-radio class="m-top" :label="'2'">在计划、安排和完成日常事务时需要少量协助</el-radio>
          <el-radio class="m-top" :label="'1'">在计划、安排和完成日常事务时需要大量协助</el-radio>
          <el-radio class="m-top" :label="'0'">完全依赖他人进行日常事务</el-radio>
        </el-radio-group><br/>
        <div class="h-line-show">25、使用交通工具外出：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.extra_info.traffic_code">
          <el-radio class="m-top" :label="'3'">能自己骑车或搭乘公共交通工具外出</el-radio>
          <el-radio class="m-top" :label="'2'">能自己搭乘出租车,但不会搭乘其他公共交通工具外出</el-radio>
          <el-radio class="m-top" :label="'1'">当有人协助或陪伴,可搭乘公共交通工具外出</el-radio>
          <el-radio class="m-top" :label="'0'">只能在他人协助下搭乘出租车或私家车外出;完全不能出门,或者外出完全需要协助</el-radio>
        </el-radio-group><br/>
        <div class="h-line-show">26、社会交往能力：</div>
        <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.extra_info.social_contact_code">
          <el-radio class="m-top" :label="'4'">参与社会,在社会环境有一定的适应能力,待人接物恰当</el-radio>
          <el-radio class="m-top" :label="'3'">能适应单纯环境,主动接触他人,初见面时难让人发现智力问题,不能理解隐喻语</el-radio>
          <el-radio class="m-top" :label="'2'">脱离社会,可被动接触,不会主动待他人,谈话中很多不适词句,容易上当受骗</el-radio>
          <el-radio class="m-top" :label="'1'">勉强可与他人接触,谈吐内容不清楚,表情不恰当</el-radio>
          <el-radio class="m-top" :label="'0'">不能与人交往</el-radio>
        </el-radio-group><br/>
      </div>
      <div class="change-clause">
        <div class="clause-title"><span>等级变更条款</span></div>
        <div style="font-size: 18px">
          <div class="h-line-show">1、昏迷：</div>
          <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.extra_info.stun">
            <el-radio class="m-top" :label="'1'">有</el-radio>
            <el-radio class="m-top" :label="'0'">无</el-radio>
          </el-radio-group><br/>
          <div class="h-line-show">2、疾病诊断(可多选)：</div>
          <el-checkbox-group style="padding-left:10px;" v-model="assessmentInfo.extra_info.illness_diagnosis_code">
            <el-checkbox class="m-top" style="display: block;" :label="'1'">高血压病 I10~I15</el-checkbox>
            <el-checkbox class="m-top" style="display: block;" :label="'2'">冠心病 I25</el-checkbox>
            <el-checkbox class="m-top" style="display: block;" :label="'3'">糖尿病 E10~E14</el-checkbox>
            <el-checkbox class="m-top" style="display: block;" :label="'4'">肺炎 J12~J18</el-checkbox>
            <el-checkbox class="m-top" style="display: block;" :label="'5'">慢性阻塞性肺疾病 J44</el-checkbox>
            <el-checkbox class="m-top" style="display: block;" :label="'6'">脑出血 I60~I62</el-checkbox>
            <el-checkbox class="m-top" style="display: block;" :label="'7'">脑梗塞 I63</el-checkbox>
            <el-checkbox class="m-top" style="display: block;" :label="'8'">尿路感染(30天内)</el-checkbox>
            <el-checkbox class="m-top" style="display: block;" :label="'9'">帕金森综合征 G20~G22</el-checkbox>
            <el-checkbox class="m-top" style="display: block;" :label="'10'">慢性肾衰竭 N18~N19</el-checkbox>
            <el-checkbox class="m-top" style="display: block;" :label="'11'">肝硬化 K74</el-checkbox>
            <el-checkbox class="m-top" style="display: block;" :label="'12'">消化性溃疡 K20~K31</el-checkbox>
            <el-checkbox class="m-top" style="display: block;" :label="'13'">肿瘤 C00~D48</el-checkbox>
            <el-checkbox class="m-top" style="display: block;" :label="'14'">截肢(6个月以内)</el-checkbox>
            <el-checkbox class="m-top" style="display: block;" :label="'15'">骨折(3个月以内) M84</el-checkbox>
            <el-checkbox class="m-top" style="display: block;" :label="'16'">癫痫 G40</el-checkbox>
            <el-checkbox class="m-top" style="display: block;" :label="'17'">甲状腺功能减退症 E01~E03</el-checkbox>
            <el-checkbox class="m-top" style="display: block;" :label="'18'">白内障 H25~H26</el-checkbox>
            <el-checkbox class="m-top" style="display: block;" :label="'19'">青光眼 H40~H42</el-checkbox>
            <el-checkbox class="m-top" style="display: block;" :label="'20'">骨质疏松症 M80~82</el-checkbox>
            <el-checkbox class="m-top" style="display: block;" :label="'21'">痴呆 F00~F03</el-checkbox>
            <el-checkbox class="m-top" style="display: block;" :label="'22'">其他精神和行为障碍 F04~F99</el-checkbox>
            <el-checkbox class="m-top" style="display: block;" :label="'23'">其他（请补充）</el-checkbox>
          </el-checkbox-group><br/>
          <el-input style="max-width: 300px;" v-model="assessmentInfo.other_disease_diagnosis" placeholder="其他疾病"></el-input><br/>
          <div class="h-line-show">3、近30天内照护风险事件：</div>
          <span>3-1、跌倒：</span><br/>
          <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.accident_frequency_fall_code">
            <el-radio class="m-top" :label="'3'">发生过3次及以上</el-radio>
            <el-radio class="m-top" :label="'2'">发生过2次</el-radio>
            <el-radio class="m-top" :label="'1'">发生过1次</el-radio>
            <el-radio class="m-top" :label="'0'">无</el-radio>
          </el-radio-group><br/>
          <span>3-2、走失：</span><br/>
          <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.accident_frequency_lost_code">
            <el-radio class="m-top" :label="'3'">发生过3次及以上</el-radio>
            <el-radio class="m-top" :label="'2'">发生过2次</el-radio>
            <el-radio class="m-top" :label="'1'">发生过1次</el-radio>
            <el-radio class="m-top" :label="'0'">无</el-radio>
          </el-radio-group><br/>
          <span>3-3、噎食：</span><br/>
          <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.accident_frequency_choking_code">
            <el-radio class="m-top" :label="'3'">发生过3次及以上</el-radio>
            <el-radio class="m-top" :label="'2'">发生过2次</el-radio>
            <el-radio class="m-top" :label="'1'">发生过1次</el-radio>
            <el-radio class="m-top" :label="'0'">无</el-radio>
          </el-radio-group><br/>
          <span>3-4、自杀、自 伤：</span><br/>
          <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.accident_frequency_suicide_code">
            <el-radio class="m-top" :label="'3'">发生过3次及以上</el-radio>
            <el-radio class="m-top" :label="'2'">发生过2次</el-radio>
            <el-radio class="m-top" :label="'1'">发生过1次</el-radio>
            <el-radio class="m-top" :label="'0'">无</el-radio>
          </el-radio-group><br/>
          <span>3-5、其他：</span><br/>
          <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.accident_frequency_other">
            <el-radio class="m-top" :label="'3'">发生过3次及以上</el-radio>
            <el-radio class="m-top" :label="'2'">发生过2次</el-radio>
            <el-radio class="m-top" :label="'1'">发生过1次</el-radio>
            <el-radio class="m-top" :label="'0'">无</el-radio>
          </el-radio-group><br/>
          <el-divider content-position="left"><strong>依据以上选项确定是否存在以下导致能力等级变更的项目：</strong></el-divider>
          <el-checkbox-group style="padding-left:10px;" v-model="assessmentInfo.extra_info.elderly_capability_change_level">
            <el-checkbox class="m-top" style="display: block; padding-top: 10px;" :label="'3'">处于昏迷状态者,直接评定为能力完全丧失(完全失能)</el-checkbox>
            <el-checkbox class="m-top" style="display: block; padding-top: 10px;" :label="'2'">确诊为痴呆(F00~F03)、精神科专科医生诊断的其他精神和行为障碍疾病(F04~F99),在原有能力级别上提高一个等级</el-checkbox>
            <el-checkbox class="m-top" style="display: block; padding-top: 10px;" :label="'1'">近30天内发生过2次及以上照护风险事件(如跌倒、噎食、自杀、自伤、走失等),在原有能力级别上提高一个等级</el-checkbox>
            <el-checkbox class="m-top" style="display: block; padding-top: 10px;" :label="'4'">无变更项目</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div class="end-title"><span>老人能力评估报告</span></div>
      <div style="height: 60px"><el-button size="small" type="primary" @click="getPrimaryGrade()">点击计算表格得分</el-button></div>
      <div>
        <table border="1" style="border-collapse: collapse;">
          <tr>
            <td rowspan="2"><div class="table-box">C.1 一级指标分级</div></td>
            <td><div class="table-box">C.1.1 自理能力得分: {{assessmentInfo.daily_activity_score}}</div></td>
            <td><div class="table-box">C.1.2基础运动能力得分: {{assessmentInfo.extra_info.sports_score}}</div></td>
          </tr>
          <tr>
            <td><div class="table-box">C.1.3 精神状态得分: {{assessmentInfo.mental_state_score}}</div></td>
            <td><div class="table-box">C.1.4 感知觉与社会参与得分: {{assessmentInfo.extra_info.society_perception_score}}</div></td>
          </tr>
          <tr>
            <td><div class="table-box">C.2 初级等级得分</div></td>
            <td colspan="2"><div class="table-box">{{assessmentInfo.extra_info.elderly_capability_primary}}</div></td>
          </tr>
          <tr>
            <td><div class="table-box">C.3 老年人能力初步等级</div></td>
            <td colspan="2"><div class="table-box">
              <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.extra_info.elderly_capability_primary_level">
                <!--  90分  -->
                <el-radio class="m-top" disabled :label="'0'">能力完好</el-radio>
                <!--  66~89分  -->
                <el-radio class="m-top" disabled :label="'1'">能力轻度受损(轻度失能)</el-radio>
                <!--  46~65分  -->
                <el-radio class="m-top" disabled :label="'2'">能力中度受损(中度失能)</el-radio>
                <!--  30~45分  -->
                <el-radio class="m-top" disabled :label="'3'">能力重度受损(重度失能)</el-radio>
                <!--  0~29分  -->
                <el-radio class="m-top" disabled :label="'4'">能力完全丧失(完全失能)</el-radio>
              </el-radio-group>
            </div></td>
          </tr>
          <tr>
            <td><div class="table-box">C.4 能力等级变更依据</div></td>
            <td colspan="2"><div class="table-box">
              <el-checkbox-group style="padding-left:10px;" v-model="assessmentInfo.extra_info.elderly_capability_change_level">
                <el-checkbox disabled style="display: block; padding-top: 10px;" :label="'3'">处于昏迷状态者,直接评定为能力完全丧失(完全失能)</el-checkbox>
                <el-checkbox disabled style="display: block; padding-top: 10px;" :label="'2'">确诊为痴呆(F00~F03)、精神科专科医生诊断的其他精神和行为障碍疾病(F04~F99),在原有能力级别上提高一个等级</el-checkbox>
                <el-checkbox disabled style="display: block; padding-top: 10px;" :label="'1'">近30天内发生过2次及以上照护风险事件(如跌倒、噎食、自杀、自伤、走失等),在原有能力级别上提高一个等级</el-checkbox>
                <el-checkbox disabled style="display: block; padding-top: 10px;" :label="'4'">无变更项目</el-checkbox>
              </el-checkbox-group>
            </div></td>
          </tr>
          <tr>
            <td><div class="table-box">C.5 老年人能力最终等级</div></td>
            <td colspan="2"><div class="table-box">
              <div>综合C.3“老年人能力初步等级”和C.4“能力等级变更依据”的结果,判定老年人能力最终等级:</div>
              <el-radio-group style="padding-left:10px;" v-model="assessmentInfo.elderly_capability_level_code">
                <el-radio class="m-top" :label="'4'">能力完好</el-radio>
                <el-radio class="m-top" :label="'3'">能力轻度受损(轻度失能)</el-radio>
                <el-radio class="m-top" :label="'2'">能力中度受损(中度失能)</el-radio>
                <el-radio class="m-top" :label="'1'">能力重度受损(重度失能)</el-radio>
                <el-radio class="m-top" :label="'0'">能力完全丧失(完全失能)</el-radio>
              </el-radio-group>
            </div></td>
          </tr>
          <tr>
            <td colspan="3">
              <div class="table-box">
                <span style="font-weight: bold">评估地点&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <el-input size="small" style="width: calc(100% - 120px)" v-model="assessmentInfo.extra_info.assessor_address" placeholder="请输入评估地点"></el-input>
                <el-row style="height: 40px">
                  <el-col :span="12">
                    <span style="font-weight: bold">评估人员姓名&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <el-input size="small" style="width: 180px" v-model="assessmentInfo.assessor_name" placeholder="请输入评估人员姓名"></el-input>
                  </el-col>
                  <el-col :span="12">
                    <span style="font-weight: bold">日期 </span>
                    <el-date-picker v-fixZoom size="small" style="width: 180px" v-model="assessmentInfo.assessment_completion_date"
                                    type="date" value-format="yyyy-MM-dd" placeholder="xxxx-xx-xx">
                    </el-date-picker>
                  </el-col>
                </el-row>
                <el-row style="height: 40px">
                  <el-col :span="12">
                    <span style="font-weight: bold">信息提供者姓名</span>
                    <el-input size="small" style="width: 180px" v-model="assessmentInfo.informant_name" placeholder="请输入信息提供者姓名"></el-input>
                  </el-col>
                  <el-col :span="12">
                    <span style="font-weight: bold">日期 </span>
                    <el-date-picker v-fixZoom size="small" style="width: 180px" v-model="assessmentInfo.evaluation_application_date"
                                    type="date" value-format="yyyy-MM-dd" placeholder="xxxx-xx-xx">
                    </el-date-picker>
                  </el-col>
                </el-row>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div style="height: 20px"></div>
    <div style="height: 80px">
      <el-button size="small" type="primary" plain @click="goback">返回</el-button>
      <el-button size="small" type="primary" icon="el-icon-download" plain @click="exportToPdf">导出PDF</el-button>
      <el-button v-if="isAdd" size="small" type="primary" @click="endSendData()">提交数据</el-button>
      <el-button v-else size="small" type="primary" @click="endSendData()">确定更改数据</el-button>
    </div>
  </div>
</template>

<script>
import {createelderlyassessmentinfo, updateelderlyassessmentinfo} from '../../api/yanglaoyuan'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
export default {
  name: 'evaluateAbility',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEditObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      imgURl: '',
      moduletag: 1,
      entityelderlyservice: '',
      oldPerson: {
        elderly_name: '',
        gender: '',
        id_number: ''
      },
      activeNames: ['1', '2'],
      isAdd: true,
      assessmentInfo: {
        id: 0,
        ep_id: '',
        evaluation_id: '',
        evaluation_form_number: '',
        evaluation_reason_type: '',
        elderly_id: '',
        elderly_name: '',
        elderly_id_card_number: '',
        acceptance_channel: '',
        informant_name: '', // 信息提供者签名
        informant_id_card_type: '',
        informant_id_card_number: '',
        informant_relationship: '',
        evaluation_authorization: true,
        evaluation_application_date: '', // 信息提供者 日期
        medical_expense_payment: '',
        economic_source_code: '',
        family_economic_status_code: '',
        living_status_code: '',
        housing_nature_code: '',
        service_application_reason_code: '',
        care_help_mode_code: '',
        medical_treatment_mode_code: '',
        family_support_status_code: '',
        community_activity_participation_code: '',
        toilet_facility_status_code: '',
        bathing_equipment_status_code: '',
        dementia_diagnosis_code: '',
        mental_illness_diagnosis_code: '',
        other_disease_diagnosis: '',
        accident_frequency_fall_code: '', // 跌倒
        accident_frequency_lost_code: '', // 走失
        accident_frequency_choking_code: '', // 噎食
        accident_frequency_suicide_code: '', // 自杀自残
        accident_frequency_other: '', // 其他
        elderly_capability_level_code: '', // C5
        daily_activity_level_code: '',
        daily_activity_score: 0, //  C1.1自理能力得分
        eating_behavior_score_code: '', // 1进食
        bathing_behavior_score_code: '', // 3洗澡
        decoration_behavior_score_code: '', // 2修饰
        dressing_behavior_score_code: '', // 4穿衣
        defecation_control_score_code: '', // 7大便
        urination_control_score_code: '', // 6小便
        toilet_behavior_score_code: '', // 8如厕
        bed_chair_transferring_score_code: '', // 10
        flat_walking_score_code: '', // 11
        stair_climbing_score_code: '', // 12
        mental_state_level_code: '',
        mental_state_score: 0, // C1.3精神状态得分
        cognitive_function_code: '',
        aggression_behavior_code: '', // 19
        depression_symptom_code: '', // 20
        perception_communication_level_code: '',
        perception_communication_score: 0,
        consciousness_level_code: '',
        vision_code: '', // 22
        hearing_code: '', // 23
        communication_code: '',
        social_participation_level_code: '',
        social_participation_score: 0,
        life_ability_code: '',
        work_ability_code: '',
        time_space_orientation_code: '',
        people_orientation_code: '',
        social_interaction_ability_code: '',
        assessor_name: '', // 评估员
        assessor_id_card_type: '',
        assessor_id_card_number: '',
        assessor_contact_number: '',
        assessor_institution_name: '',
        assessment_administrative_division_code: '',
        assessment_completion_date: '',
        eldercare_service_recommendation_code: '',
        caregiving_level_code: '',
        service_mode_code: '',
        supervisor_name: '',
        supervisor_contact_number: '',
        supervisor_unit: '',
        sampling_date: '',
        sampling_conclusion_code: '',
        confirmation_responsible_person_name: '',
        confirmation_responsible_person_contact_number: '',
        confirmation_responsible_person_unit_name: '',
        confirmation_date: '',
        street_town_assessment_confirmation_code: '',
        extra_info: {
          dressing_trousers_score_code: '', // 5
          bed_body_transferring_score_code: '', // 9
          time_score_code: '', // 13
          space_score_code: '', // 14
          person_score_code: '', // 15
          memory_score_code: '', // 16
          comprehend_score_code: '', // 17
          expression_score_code: '', // 18
          consciousness_score_code: '', // 21
          daily_code: '', // 24
          traffic_code: '', // 25
          social_contact_code: '', // 26
          sports_score: 0, // C1.2基础运动得分
          society_perception_score: 0, // C1.3感知觉与社会参与
          elderly_capability_primary: '', // C2
          elderly_capability_primary_level: '', // C3
          elderly_capability_change_level: [], // C4/变更条款等级
          stun: '', // 昏迷
          illness_diagnosis_code: [], // 疾病诊断
          assessor_address: '' // 评估地点
        }
      }
    }
  },
  created () {
    this.moduletag = this.$store.state.user.moduletag
    this.oldPerson = this.addEditObj.oldPersonRow
    this.isAdd = this.addEditObj.isAdd
    this.assessmentInfo.ep_id = this.addEditObj.oldPersonRow.id
    this.getOldPersonInfoData()
    if (!this.isAdd) {
      this.getEditData()
    }
  },
  methods: {
    getgender (gender) {
      if (gender === '0') {
        return '未知性别'
      } else if (gender === '1') {
        return '男性'
      } else if (gender === '2') {
        return '女性'
      } else if (gender === '9') {
        return '未说明性别'
      } else {
        return gender
      }
    },
    getOldPersonInfoData () {
      if (this.moduletag === 2) {
        this.assessmentInfo.elderly_id = this.oldPerson.elderly_id
        this.assessmentInfo.elderly_name = this.oldPerson.elderly_name
        this.assessmentInfo.elderly_id_card_number = this.oldPerson.id_number
      } else {
        this.assessmentInfo.elderly_name = this.oldPerson.name
        this.assessmentInfo.elderly_id_card_number = this.oldPerson.idcard_num
      }
    },
    getEditData () {
      let form = this.addEditObj.row
      let info = this.addEditObj.row.extra_info !== '' ? this.addEditObj.row.extra_info : null
      let extraInfo = {
        dressing_trousers_score_code: info.dressing_trousers_score_code ? info.dressing_trousers_score_code : '', // 5
        bed_body_transferring_score_code: info.bed_body_transferring_score_code ? info.bed_body_transferring_score_code : '', // 9
        time_score_code: info.time_score_code ? info.time_score_code : '', // 13
        space_score_code: info.space_score_code ? info.space_score_code : '', // 14
        person_score_code: info.person_score_code ? info.person_score_code : '', // 15
        memory_score_code: info.memory_score_code ? info.memory_score_code : '', // 16
        comprehend_score_code: info.comprehend_score_code ? info.comprehend_score_code : '', // 17
        expression_score_code: info.expression_score_code ? info.expression_score_code : '', // 18
        consciousness_score_code: info.consciousness_score_code ? info.consciousness_score_code : '', // 21
        daily_code: info.daily_code ? info.daily_code : '', // 24
        traffic_code: info.traffic_code ? info.traffic_code : '', // 25
        social_contact_code: info.social_contact_code ? info.social_contact_code : '', // 26
        sports_score: info.sports_score ? info.sports_score : 0, // C1.2基础运动得分
        society_perception_score: info.society_perception_score ? info.society_perception_score : 0, // C1.3感知觉与社会参与
        elderly_capability_primary: info.elderly_capability_primary ? info.elderly_capability_primary : '', // C2
        elderly_capability_primary_level: info.elderly_capability_primary_level ? info.elderly_capability_primary_level : '', // C3
        elderly_capability_change_level: info.elderly_capability_change_level ? info.elderly_capability_change_level : [], // C4/变更条款等级
        stun: info.stun ? info.stun : '', // 昏迷
        illness_diagnosis_code: info.illness_diagnosis_code ? info.illness_diagnosis_code : [], // 疾病诊断
        assessor_address: info.assessor_address ? info.assessor_address : '' // 评估地点
      }
      form.extra_info = extraInfo
      // console.log(info, extraInfo)
      this.assessmentInfo = form
    },
    goback () {
      this.$emit('change', false)
    },
    // C.1.1自理能力得分 1-8
    saveSelfCare () {
      if (this.assessmentInfo.eating_behavior_score_code === '' || this.assessmentInfo.decoration_behavior_score_code === '' || this.assessmentInfo.bathing_behavior_score_code === '' ||
        this.assessmentInfo.dressing_behavior_score_code === '' || this.assessmentInfo.extra_info.dressing_trousers_score_code === '' || this.assessmentInfo.urination_control_score_code === '' ||
        this.assessmentInfo.defecation_control_score_code === '' || this.assessmentInfo.toilet_behavior_score_code === '') {
        this.$message({ message: '请选择完整的自理能力信息。', type: 'warning' })
        return
      }
      let grade = parseInt(this.assessmentInfo.eating_behavior_score_code) + parseInt(this.assessmentInfo.decoration_behavior_score_code) + parseInt(this.assessmentInfo.bathing_behavior_score_code) +
        parseInt(this.assessmentInfo.dressing_behavior_score_code) + parseInt(this.assessmentInfo.extra_info.dressing_trousers_score_code) + parseInt(this.assessmentInfo.urination_control_score_code) +
          parseInt(this.assessmentInfo.defecation_control_score_code) + parseInt(this.assessmentInfo.toilet_behavior_score_code)
      // console.log('C.1.1', grade)
      this.assessmentInfo.daily_activity_score = grade
    },
    // C.1.2运动能力得分 9-12
    saveSports () {
      if (this.assessmentInfo.extra_info.bed_body_transferring_score_code === '' || this.assessmentInfo.bed_chair_transferring_score_code === '' ||
        this.assessmentInfo.flat_walking_score_code === '' || this.assessmentInfo.stair_climbing_score_code === '') {
        this.$message({ message: '请选择完整的基础运动信息。', type: 'warning' })
        return
      }
      let grade = parseInt(this.assessmentInfo.extra_info.bed_body_transferring_score_code) + parseInt(this.assessmentInfo.bed_chair_transferring_score_code) +
        parseInt(this.assessmentInfo.flat_walking_score_code) + parseInt(this.assessmentInfo.stair_climbing_score_code)
      // console.log('C.1.2', grade)
      this.assessmentInfo.extra_info.sports_score = grade
    },
    // C.1.3精神状态得分 13-21
    saveMentalState () {
      if (this.assessmentInfo.extra_info.time_score_code === '' || this.assessmentInfo.extra_info.space_score_code === '' || this.assessmentInfo.extra_info.person_score_code === '' ||
        this.assessmentInfo.extra_info.memory_score_code === '' || this.assessmentInfo.extra_info.comprehend_score_code === '' || this.assessmentInfo.extra_info.expression_score_code === '' ||
        this.assessmentInfo.aggression_behavior_code === '' || this.assessmentInfo.depression_symptom_code === '' || this.assessmentInfo.extra_info.consciousness_score_code === '') {
        this.$message({ message: '请选择完整的精神状态信息。', type: 'warning' })
        return
      }
      let grade = parseInt(this.assessmentInfo.extra_info.time_score_code) + parseInt(this.assessmentInfo.extra_info.space_score_code) + parseInt(this.assessmentInfo.extra_info.person_score_code) +
        parseInt(this.assessmentInfo.extra_info.memory_score_code) + parseInt(this.assessmentInfo.extra_info.comprehend_score_code) + parseInt(this.assessmentInfo.extra_info.expression_score_code) +
          parseInt(this.assessmentInfo.aggression_behavior_code) + parseInt(this.assessmentInfo.depression_symptom_code) + parseInt(this.assessmentInfo.extra_info.consciousness_score_code)
      // console.log('C.1.3', grade)
      this.assessmentInfo.mental_state_score = grade
    },
    // C.1.4 感知觉与社会参与得分 22-26
    saveCommunication () {
      if (this.assessmentInfo.vision_code === '' || this.assessmentInfo.hearing_code === '' || this.assessmentInfo.extra_info.daily_code === '' ||
        this.assessmentInfo.extra_info.traffic_code === '' || this.assessmentInfo.extra_info.social_contact_code === '') {
        this.$message({ message: '请选择完整的感知觉与社会参与信息。', type: 'warning' })
        return
      }
      let grade = parseInt(this.assessmentInfo.vision_code) + parseInt(this.assessmentInfo.hearing_code) + parseInt(this.assessmentInfo.extra_info.daily_code) +
        parseInt(this.assessmentInfo.extra_info.traffic_code) + parseInt(this.assessmentInfo.extra_info.social_contact_code)
      // console.log('C.1.4', grade)
      this.assessmentInfo.extra_info.society_perception_score = grade
    },
    // 变更条款
    changeClause () {
      if (this.assessmentInfo.extra_info.stun === '' || this.assessmentInfo.extra_info.illness_diagnosis_code.length === 0 || this.assessmentInfo.accident_frequency_fall_code === '' ||
        this.assessmentInfo.accident_frequency_lost_code === '' || this.assessmentInfo.accident_frequency_choking_code === '' || this.assessmentInfo.accident_frequency_suicide_code === '' ||
      this.assessmentInfo.accident_frequency_other === '' || this.assessmentInfo.extra_info.elderly_capability_change_level.length === 0) {
        this.$message({ message: '请选择变更条款信息。', type: 'warning' })
        return false
      }
      let grade = parseInt(this.assessmentInfo.daily_activity_score) + parseInt(this.assessmentInfo.extra_info.sports_score) +
        parseInt(this.assessmentInfo.mental_state_score) + parseInt(this.assessmentInfo.extra_info.society_perception_score)
      // console.log('C2', grade)
      this.assessmentInfo.extra_info.elderly_capability_primary = grade
      if (grade < 30) {
        this.assessmentInfo.extra_info.elderly_capability_primary_level = '4'
      } else if (grade >= 30 && grade < 46) {
        this.assessmentInfo.extra_info.elderly_capability_primary_level = '3'
      } else if (grade >= 46 && grade < 66) {
        this.assessmentInfo.extra_info.elderly_capability_primary_level = '2'
      } else if (grade >= 66 && grade < 90) {
        this.assessmentInfo.extra_info.elderly_capability_primary_level = '1'
      } else if (grade >= 90) {
        this.assessmentInfo.extra_info.elderly_capability_primary_level = '0'
      }
      return true
      // console.log('C3', this.assessmentInfo.extra_info.elderly_capability_primary_level)
      // console.log('C4', this.assessmentInfo.extra_info.elderly_capability_change_level)
    },
    getPrimaryGrade () {
      if (this.getISInfo()) {
        this.$message({ message: '填写完整，请提交数据。', type: 'success' })
      }
    },
    // 判断是否填完整数据
    getISInfo () {
      // C.1.1自理能力得分:
      if (this.assessmentInfo.eating_behavior_score_code === '' || this.assessmentInfo.decoration_behavior_score_code === '' || this.assessmentInfo.bathing_behavior_score_code === '' ||
        this.assessmentInfo.dressing_behavior_score_code === '' || this.assessmentInfo.extra_info.dressing_trousers_score_code === '' || this.assessmentInfo.urination_control_score_code === '' ||
        this.assessmentInfo.defecation_control_score_code === '' || this.assessmentInfo.toilet_behavior_score_code === '') {
        this.$message({ message: '请选择完整的自理能力信息。', type: 'warning' })
        return false
      } else {
        this.saveSelfCare()
      }
      // C.1.2运动能力得分
      if (this.assessmentInfo.extra_info.bed_body_transferring_score_code === '' || this.assessmentInfo.bed_chair_transferring_score_code === '' ||
        this.assessmentInfo.flat_walking_score_code === '' || this.assessmentInfo.stair_climbing_score_code === '') {
        this.$message({ message: '请选择完整的基础运动信息。', type: 'warning' })
        return false
      } else {
        this.saveSports()
      }
      // C.1.3精神状态得分
      if (this.assessmentInfo.extra_info.time_score_code === '' || this.assessmentInfo.extra_info.space_score_code === '' || this.assessmentInfo.extra_info.person_score_code === '' ||
        this.assessmentInfo.extra_info.memory_score_code === '' || this.assessmentInfo.extra_info.comprehend_score_code === '' || this.assessmentInfo.extra_info.expression_score_code === '' ||
        this.assessmentInfo.aggression_behavior_code === '' || this.assessmentInfo.depression_symptom_code === '' || this.assessmentInfo.extra_info.consciousness_score_code === '') {
        this.$message({ message: '请选择完整的精神状态信息。', type: 'warning' })
        return false
      } else {
        this.saveMentalState()
      }
      // C.1.4 感知觉与社会参与得分
      if (this.assessmentInfo.vision_code === '' || this.assessmentInfo.hearing_code === '' || this.assessmentInfo.extra_info.daily_code === '' ||
        this.assessmentInfo.extra_info.traffic_code === '' || this.assessmentInfo.extra_info.social_contact_code === '') {
        this.$message({ message: '请选择完整的感知觉与社会参与信息。', type: 'warning' })
        return false
      } else {
        this.saveCommunication()
      }
      let grade = parseInt(this.assessmentInfo.daily_activity_score) + parseInt(this.assessmentInfo.extra_info.sports_score) +
        parseInt(this.assessmentInfo.mental_state_score) + parseInt(this.assessmentInfo.extra_info.society_perception_score)
      // console.log('C2', grade)
      this.assessmentInfo.extra_info.elderly_capability_primary = grade
      if (grade < 30) {
        this.assessmentInfo.extra_info.elderly_capability_primary_level = '4'
      } else if (grade >= 30 && grade < 46) {
        this.assessmentInfo.extra_info.elderly_capability_primary_level = '3'
      } else if (grade >= 46 && grade < 66) {
        this.assessmentInfo.extra_info.elderly_capability_primary_level = '2'
      } else if (grade >= 66 && grade < 90) {
        this.assessmentInfo.extra_info.elderly_capability_primary_level = '1'
      } else if (grade >= 90) {
        this.assessmentInfo.extra_info.elderly_capability_primary_level = '0'
      }
      if (this.changeClause()) {} else {
        return false
      }
      this.changeClause() // C.4
      if (this.assessmentInfo.elderly_capability_level_code === '') {
        this.$message({ message: '请选择 C.5老年人能力最终等级。', type: 'warning' })
        return false
      }
      if (this.assessmentInfo.assessor_address === '') {
        this.$message({ message: '请输入评估地点。', type: 'warning' })
        return false
      }
      if (this.assessmentInfo.assessor_name === '') {
        this.$message({ message: '请输入评估人员姓名。', type: 'warning' })
        return false
      }
      if (this.assessmentInfo.informant_name === '') {
        this.$message({ message: '请输入信息提供者姓名。', type: 'warning' })
        return false
      }
      if (this.assessmentInfo.assessment_completion_date === '' || this.assessmentInfo.evaluation_application_date === '') {
        this.$message({ message: '请选择日期。', type: 'warning' })
        return false
      }
      return true
    },
    endSendData () {
      // console.log('最终提交')
      if (this.getISInfo()) {
        let data = this.clone(this.assessmentInfo)
        data.extra_info = JSON.stringify(this.assessmentInfo.extra_info)
        // console.log(this.assessmentInfo, data)
        if (this.isAdd) {
          createelderlyassessmentinfo(data).then(res => {
            this.$notify({title: '成功', message: '成功创建老人评估信息', type: 'success'})
            this.$emit('updateData')
            this.$emit('change', false)
          }).catch(() => {
          })
        } else {
          updateelderlyassessmentinfo(data).then(res => {
            this.$notify({title: '成功', message: '成功编辑老人评估信息', type: 'success'})
            this.$emit('updateData')
            this.$emit('change', false)
          }).catch(() => {
          })
        }
      }
    },
    // 导出 PDF
    async exportToPdf () {
      // 获取要导出的DOM元素
      const element = this.$refs.contentToConvert
      // 设置PDF选项
      // eslint-disable-next-line new-cap
      const pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
      })
      // 计算A4纸尺寸
      const pageWidth = pdf.internal.pageSize.getWidth()
      const pageHeight = pdf.internal.pageSize.getHeight()
      console.log('a4', pageWidth, pageHeight)
      // 设置边距
      const margin = 5 // mm
      const contentWidth = pageWidth - margin * 2
      // 获取元素原始尺寸
      const elementWidth = element.scrollWidth
      const elementHeight = element.scrollHeight
      console.log('原始尺寸', elementWidth, elementHeight)

      // 获取元素宽度（包含边框和内边距，不包含外边距）
      const width = element.offsetWidth
      // 获取元素高度
      const height = element.offsetHeight
      console.log(width, height)

      // 计算缩放比例（确保内容宽度适合PDF页面）
      const scale = contentWidth / elementWidth
      // console.log('scale', scale, scale * 2, (1 - scale * 3))
      // 计算每页在DOM中对应的高度
      const pageContentHeight = (pageHeight - margin * 2) / scale
      let position = 0
      // 添加加载提示
      this.$message.info('正在生成PDF，请稍候...')
      try {
        while (position < elementHeight) {
          // 计算当前页要截取的高度
          const currentHeight = Math.min(pageContentHeight, elementHeight - position)
          console.log(position, elementHeight, currentHeight)
          // 使用html2canvas渲染当前页内容
          const canvas = await html2canvas(element, {
            scale: 2, // 提高DPI使图片更清晰
            // scale: 0.9,
            y: position,
            height: currentHeight,
            width: elementWidth,
            windowHeight: currentHeight,
            windowWidth: elementWidth,
            useCORS: true, // 允许跨域图片
            allowTaint: true, // 允许不同源图片
            logging: false, // 关闭日志
            backgroundColor: '#FFFFFF' // 白色背景
          })
          // 将canvas转为图片
          const imgData = canvas.toDataURL('image/jpeg', 1.0) // 使用JPEG格式，质量为1.0
          this.imgURl = imgData
          // 添加新页（第一页不需要）
          if (position > 1) {
            pdf.addPage()
          }
          // 添加图片到PDF
          pdf.addImage({
            imageData: imgData,
            x: margin,
            y: margin,
            width: contentWidth,
            height: canvas.height * contentWidth / canvas.width
          })
          position += currentHeight
        }
        // 保存PDF
        pdf.save('老年人能力评估基本信息表.pdf')
        this.$message.success('PDF导出成功！')
      } catch (error) {
        console.error('导出PDF失败:', error)
        this.$message.error('PDF导出失败，请重试')
      }
    }
  }
}
</script>

<style scoped>
.m-top{
  min-height: 30px;
}
.h-line-show{
  font-weight: bold;
  height: 40px;
  line-height: 40px;
}
.capture-area {
  position: relative;
  box-sizing: border-box;
  transform: none !important; /* 禁用所有变换 */
  width: 100% !important; /* 固定宽度 */
  overflow: visible !important;
}
/* 添加到截图元素的父容器 */
.no-zoom-container {
  transform: none !important;
  zoom: 1 !important;
  scale: 1 !important;
}
/* 禁用所有子元素的变换 */
.no-zoom-container * {
  transform: none !important;
  zoom: 1 !important;
  scale: 1 !important;
}
/deep/ .el-radio{
  display: block;
  line-height: 23px;
  white-space: normal;
  margin-right: 0;
}
.change-clause{
  padding: 10px;
  border-radius: 20px;
  border:1px dashed #458FD2;
  min-height: 100px;
  box-sizing: border-box;
}
.clause-title{
  height: 40px;
  font-weight: 800;
  font-size: 18px;
  color: #1a1a1a;
}
.clause-title-line{
  height: 40px;
  line-height: 40px;
  font-weight: 500;
  font-size: 18px;
  color: #1a1a1a;
  background-color: aliceblue;
  padding-left: 20px;
}
.end-title{
  height: 40px;
  line-height: 40px;
  margin-left: 10px;
  font-weight: 800;
  font-size: 18px;
  color: #1a1a1a;
}
.table-box{
  padding: 10px;
}
.inpt-line{
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid #1a1a1a;
  outline: none;
}
.box-card{
  letter-spacing: 4px;
  margin: 0 10px;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/evaluateAbility/evaluateAbility.vue